module.exports = __webpack_public_path__ + "img/menu-icon-search.bd51d44e.svg";